import {
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';

import { CustomModal } from '../../../../components/custom';
import {
  EditIcon,
  EllipsesVerticalIcon,
  FullEyeIcon,
  TrashMiniRedIcon,
} from '../../../../components/icons';
import { useAppSelector } from '../../../../store/hooks';
import { IBillBeneficiary } from '../../../../types/beneficiary';
import DeleteBeneficiaryConfirmation from '../../../Transfers/Beneficiaries/ManageBeneficiaries/DeleteBeneficiaryConfirmation';
import ViewEditBeneficiary from './ViewEditBeneficiary';

interface BeneficiaryMenuProps {
  beneficiary: IBillBeneficiary;
}

export default function BeneficiaryCardMenu({
  beneficiary,
}: BeneficiaryMenuProps) {
  const [type, setType] = useState('');
  const { status: beneficiaryDeleteStatus } = useAppSelector(
    (state) => state.beneficiaryDelete
  );

  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModalOpen,
    onClose: onDeleteModalClose,
  } = useDisclosure();

  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();

  const deleteBtnRef = useRef<HTMLButtonElement>(null);
  const btnRef = useRef<HTMLButtonElement>(null);

  const handleDeleteModalClose = () => {
    if (beneficiaryDeleteStatus === 'loading') return;

    onDeleteModalClose();
  };

  const handleOpen = (type: string) => {
    setType(() => type);
    onModalOpen();
  };

  return (
    <Box>
      <Menu placement="left-start">
        <MenuButton
          as={IconButton}
          aria-label="Beneficiary Actions"
          icon={<EllipsesVerticalIcon boxSize="20px" />}
          variant="unstyled"
          boxSize="20px"
        />
        <MenuList>
          <MenuItem
            icon={<FullEyeIcon />}
            borderRadius="4px"
            width="90px"
            height="28px"
            onClick={() => handleOpen('view')}
            ref={btnRef}
            isDisabled={beneficiaryDeleteStatus === 'loading'}
          >
            View
          </MenuItem>
          <MenuItem
            icon={<EditIcon />}
            borderRadius="4px"
            width="90px"
            height="28px"
            onClick={() => handleOpen('edit')}
            ref={btnRef}
            isDisabled={beneficiaryDeleteStatus === 'loading'}
          >
            Edit
          </MenuItem>
          <MenuItem
            icon={<TrashMiniRedIcon />}
            background="#ffeceb"
            borderRadius="4px"
            width="90px"
            height="28px"
            color="red.500"
            onClick={onDeleteModalOpen}
            ref={deleteBtnRef}
            isDisabled={beneficiaryDeleteStatus === 'loading'}
          >
            Delete
          </MenuItem>
        </MenuList>
      </Menu>

      <CustomModal
        isOpen={isDeleteModalOpen}
        onClose={handleDeleteModalClose}
        btnRef={deleteBtnRef}
      >
        <DeleteBeneficiaryConfirmation
          type="bill"
          billBeneficiary={beneficiary}
        />
      </CustomModal>
      <CustomModal isOpen={isModalOpen} onClose={onModalClose} btnRef={btnRef}>
        <ViewEditBeneficiary type={type} billBeneficiary={beneficiary} />
      </CustomModal>
    </Box>
  );
}
